/**
 * Catálogo Basic toolbar estilo VectorCraft.
 * Fuente: vectorcraft-ref/crates/ui-egui/src/toolbar.rs `BASIC`
 * + tools/src/catalog.rs. Categorías en ES como la UI de VC.
 * `ready: true` = cableado al moodboard.
 */

/** @typedef {'select'|'mark'|'slot'|'nav'|'meta'|'soon'} ToolKind */

/**
 * @typedef {object} VcTool
 * @property {string} id
 * @property {string} label
 * @property {string} [shortcut]
 * @property {boolean} ready
 * @property {ToolKind} kind
 * @property {string} [mark]
 * @property {string} [action]
 */

/** @type {Array<{ category: string, slots: VcTool[][] }>} */
export const VC_BASIC_TOOLBAR = [
  {
    category: "Selección",
    slots: [
      [
        {
          id: "selection",
          label: "Selección",
          shortcut: "V",
          ready: true,
          kind: "select",
        },
      ],
      [
        {
          id: "directSelection",
          label: "Selección directa",
          shortcut: "A",
          ready: true,
          kind: "mark",
          mark: "directSelect",
        },
        {
          id: "groupSelection",
          label: "Selección de grupos",
          ready: true,
          kind: "meta",
          action: "groupSelection",
        },
        {
          id: "groupMarks",
          label: "Agrupar",
          shortcut: "Ctrl+G",
          ready: true,
          kind: "meta",
          action: "groupMarks",
        },
        {
          id: "ungroupMarks",
          label: "Desagrupar",
          shortcut: "Ctrl+Shift+G",
          ready: true,
          kind: "meta",
          action: "ungroupMarks",
        },
      ],
      [
        {
          id: "lasso",
          label: "Lazo",
          shortcut: "Q",
          ready: true,
          kind: "mark",
          mark: "lasso",
        },
        {
          id: "magicWand",
          label: "Varita mágica",
          shortcut: "Y",
          ready: true,
          kind: "mark",
          mark: "magicWand",
        },
      ],
    ],
  },
  {
    category: "Formas",
    slots: [
      [
        {
          id: "rectangle",
          label: "Rectángulo",
          shortcut: "M",
          ready: true,
          kind: "mark",
          mark: "rect",
        },
        {
          id: "roundedRectangle",
          label: "Rectángulo redondeado",
          ready: true,
          kind: "mark",
          mark: "roundrect",
        },
        {
          id: "star",
          label: "Estrella",
          ready: true,
          kind: "mark",
          mark: "star",
        },
        {
          id: "lineSegment",
          label: "Segmento de línea",
          shortcut: "\\",
          ready: true,
          kind: "mark",
          mark: "line",
        },
        {
          id: "arc",
          label: "Arco",
          ready: true,
          kind: "mark",
          mark: "arc",
        },
        {
          id: "spiral",
          label: "Espiral",
          ready: true,
          kind: "mark",
          mark: "spiral",
        },
        {
          id: "rectangularGrid",
          label: "Cuadrícula rectangular",
          ready: true,
          kind: "mark",
          mark: "grid",
        },
        {
          id: "polarGrid",
          label: "Cuadrícula polar",
          ready: true,
          kind: "mark",
          mark: "polarGrid",
        },
        {
          id: "flare",
          label: "Destello",
          ready: true,
          kind: "mark",
          mark: "flare",
        },
        {
          id: "arrow",
          label: "Flecha",
          ready: true,
          kind: "mark",
          mark: "arrow",
        },
      ],
      [
        {
          id: "ellipse",
          label: "Elipse",
          shortcut: "L",
          ready: true,
          kind: "mark",
          mark: "ellipse",
        },
      ],
      [
        {
          id: "polygon",
          label: "Polígono",
          ready: true,
          kind: "mark",
          mark: "polygon",
        },
      ],
      [
        {
          id: "shaper",
          label: "Shaper",
          shortcut: "Shift+N",
          ready: true,
          kind: "mark",
          mark: "shaper",
        },
      ],
    ],
  },
  {
    category: "Dibujar",
    slots: [
      [
        {
          id: "pencil",
          label: "Lápiz",
          shortcut: "N",
          ready: true,
          kind: "mark",
          mark: "pen",
        },
        {
          id: "smooth",
          label: "Suavizar",
          ready: true,
          kind: "meta",
          action: "smoothSelection",
        },
        {
          id: "pathEraser",
          label: "Borrador de trazos",
          ready: true,
          kind: "mark",
          mark: "pathEraser",
        },
        {
          id: "join",
          label: "Unir trazos",
          ready: true,
          kind: "meta",
          action: "joinPaths",
        },
        {
          id: "offsetPath",
          label: "Offset Path…",
          ready: true,
          kind: "meta",
          action: "offsetPath",
        },
        {
          id: "outlineStroke",
          label: "Outline Stroke",
          ready: true,
          kind: "meta",
          action: "outlineStroke",
        },
        {
          id: "simplifyPath",
          label: "Simplify…",
          ready: true,
          kind: "meta",
          action: "simplifyPath",
        },
        {
          id: "averageAnchors",
          label: "Average…",
          ready: true,
          kind: "meta",
          action: "averageAnchors",
        },
      ],
      [
        {
          id: "eraser",
          label: "Borrador",
          shortcut: "Shift+E",
          ready: true,
          kind: "mark",
          mark: "eraser",
        },
        {
          id: "scissors",
          label: "Tijeras",
          shortcut: "C",
          ready: true,
          kind: "mark",
          mark: "scissors",
        },
        {
          id: "knife",
          label: "Cuchilla",
          ready: true,
          kind: "mark",
          mark: "knife",
        },
        {
          id: "mirrorCut",
          label: "Reflejar y cortar",
          ready: true,
          kind: "mark",
          mark: "mirrorCut",
        },
        {
          id: "lineCut",
          label: "Corte de línea",
          ready: true,
          kind: "mark",
          mark: "lineCut",
        },
        {
          id: "rectCut",
          label: "Corte rectangular",
          ready: true,
          kind: "mark",
          mark: "rectCut",
        },
      ],
      [
        {
          id: "paintbrush",
          label: "Pincel",
          shortcut: "B",
          ready: true,
          kind: "mark",
          mark: "brush",
        },
        {
          id: "blobBrush",
          label: "Pincel de manchas",
          shortcut: "Shift+B",
          ready: true,
          kind: "mark",
          mark: "blob",
        },
      ],
      [
        {
          id: "pen",
          label: "Pluma",
          shortcut: "P",
          ready: true,
          kind: "mark",
          mark: "vectorPen",
        },
        {
          id: "addAnchor",
          label: "Agregar punto de ancla",
          shortcut: "+",
          ready: true,
          kind: "mark",
          mark: "addAnchor",
        },
        {
          id: "deleteAnchor",
          label: "Eliminar punto de ancla",
          shortcut: "-",
          ready: true,
          kind: "mark",
          mark: "deleteAnchor",
        },
        {
          id: "anchorPoint",
          label: "Punto de ancla",
          shortcut: "Shift+C",
          ready: true,
          kind: "mark",
          mark: "anchorPoint",
        },
      ],
      [
        {
          id: "curvature",
          label: "Curvatura",
          ready: true,
          kind: "mark",
          mark: "curvature",
        },
      ],
    ],
  },
  {
    category: "Modificar",
    slots: [
      [
        {
          id: "width",
          label: "Anchura",
          shortcut: "Shift+W",
          ready: true,
          kind: "mark",
          mark: "width",
        },
        {
          id: "warp",
          label: "Deformar",
          ready: true,
          kind: "mark",
          mark: "warp",
        },
        {
          id: "puppetWarp",
          label: "Puppet Warp",
          ready: true,
          kind: "mark",
          mark: "puppetWarp",
        },
        {
          id: "twirl",
          label: "Molinete",
          ready: true,
          kind: "mark",
          mark: "twirl",
        },
        {
          id: "pucker",
          label: "Fruncir",
          ready: true,
          kind: "mark",
          mark: "pucker",
        },
        {
          id: "bloat",
          label: "Engordar",
          ready: true,
          kind: "mark",
          mark: "bloat",
        },
        {
          id: "scallop",
          label: "Festonear",
          ready: true,
          kind: "mark",
          mark: "scallop",
        },
        {
          id: "crystallize",
          label: "Cristalizar",
          ready: true,
          kind: "mark",
          mark: "crystallize",
        },
        {
          id: "wrinkle",
          label: "Arrugar",
          ready: true,
          kind: "mark",
          mark: "wrinkle",
        },
      ],
      [
        {
          id: "rotate",
          label: "Rotar",
          shortcut: "R",
          ready: true,
          kind: "mark",
          mark: "rotateDrag",
        },
        {
          id: "reflect",
          label: "Reflejar",
          shortcut: "O",
          ready: true,
          kind: "meta",
          action: "reflectSelection",
        },
        {
          id: "flipVertical",
          label: "Voltear vertical",
          ready: true,
          kind: "meta",
          action: "flipVertical",
        },
        {
          id: "scale",
          label: "Escalar",
          shortcut: "S",
          ready: true,
          kind: "mark",
          mark: "scaleDrag",
        },
        {
          id: "shear",
          label: "Inclinar",
          ready: true,
          kind: "mark",
          mark: "shearDrag",
        },
        {
          id: "reshape",
          label: "Reformar",
          ready: true,
          kind: "mark",
          mark: "reshape",
        },
        {
          id: "freeTransform",
          label: "Transformación libre",
          shortcut: "E",
          ready: true,
          kind: "meta",
          action: "freeTransform",
        },
        {
          id: "duplicate",
          label: "Duplicar",
          shortcut: "Ctrl+D",
          ready: true,
          kind: "meta",
          action: "duplicateSelection",
        },
      ],
      [
        {
          id: "shapeBuilder",
          label: "Pathfinder · Unir",
          shortcut: "Shift+M",
          ready: true,
          kind: "meta",
          action: "shapeBuilder:unite",
        },
        {
          id: "shapeBuilderMinus",
          label: "Pathfinder · Restar",
          ready: true,
          kind: "meta",
          action: "shapeBuilder:minus",
        },
        {
          id: "shapeBuilderIntersect",
          label: "Pathfinder · Intersectar",
          ready: true,
          kind: "meta",
          action: "shapeBuilder:intersect",
        },
        {
          id: "shapeBuilderExclude",
          label: "Pathfinder · Excluir",
          ready: true,
          kind: "meta",
          action: "shapeBuilder:exclude",
        },
        {
          id: "livePaintBucket",
          label: "Live Paint · Bote",
          shortcut: "K",
          ready: true,
          kind: "mark",
          mark: "livePaintBucket",
        },
        {
          id: "livePaintSelection",
          label: "Live Paint · Selección",
          shortcut: "Shift+L",
          ready: true,
          kind: "mark",
          mark: "livePaintSelection",
        },
        {
          id: "makeClippingMask",
          label: "Crear máscara de recorte",
          shortcut: "Ctrl+7",
          ready: true,
          kind: "meta",
          action: "makeClippingMask",
        },
        {
          id: "releaseClippingMask",
          label: "Liberar máscara de recorte",
          shortcut: "Ctrl+Alt+7",
          ready: true,
          kind: "meta",
          action: "releaseClippingMask",
        },
        {
          id: "blend",
          label: "Fusión",
          shortcut: "W",
          ready: true,
          kind: "meta",
          action: "blendMarks",
        },
        {
          id: "envelopeWarp",
          label: "Envelope · Warp",
          ready: true,
          kind: "meta",
          action: "envelopeWarp",
        },
        {
          id: "envelopeMesh",
          label: "Envelope · Mesh",
          ready: true,
          kind: "meta",
          action: "envelopeMesh",
        },
        {
          id: "objectsOnPath",
          label: "Objects on Path",
          ready: true,
          kind: "mark",
          mark: "objectsOnPath",
        },
        {
          id: "expandObjectsOnPath",
          label: "Expand Objects on Path",
          ready: true,
          kind: "meta",
          action: "expandObjectsOnPath",
        },
        {
          id: "symbolShifter",
          label: "Symbol Shifter",
          ready: true,
          kind: "mark",
          mark: "symbolShifter",
        },
        {
          id: "symbolSprayer",
          label: "Symbol Sprayer",
          ready: true,
          kind: "mark",
          mark: "symbolSprayer",
        },
        {
          id: "symbolScruncher",
          label: "Symbol Scruncher",
          ready: true,
          kind: "mark",
          mark: "symbolScruncher",
        },
        {
          id: "symbolSizer",
          label: "Symbol Sizer",
          ready: true,
          kind: "mark",
          mark: "symbolSizer",
        },
        {
          id: "symbolSpinner",
          label: "Symbol Spinner",
          ready: true,
          kind: "mark",
          mark: "symbolSpinner",
        },
        {
          id: "symbolStainer",
          label: "Symbol Stainer",
          ready: true,
          kind: "mark",
          mark: "symbolStainer",
        },
        {
          id: "symbolScreener",
          label: "Symbol Screener",
          ready: true,
          kind: "mark",
          mark: "symbolScreener",
        },
        {
          id: "defineSymbol",
          label: "Define Symbol",
          ready: true,
          kind: "meta",
          action: "defineSymbol",
        },
        {
          id: "bringToFront",
          label: "Traer al frente",
          ready: true,
          kind: "meta",
          action: "bringToFront",
        },
        {
          id: "sendToBack",
          label: "Enviar atrás",
          ready: true,
          kind: "meta",
          action: "sendToBack",
        },
        {
          id: "alignLeft",
          label: "Alinear izquierda",
          ready: true,
          kind: "meta",
          action: "align:left",
        },
        {
          id: "alignHCenter",
          label: "Alinear centro H",
          ready: true,
          kind: "meta",
          action: "align:hcenter",
        },
        {
          id: "alignRight",
          label: "Alinear derecha",
          ready: true,
          kind: "meta",
          action: "align:right",
        },
        {
          id: "alignTop",
          label: "Alinear arriba",
          ready: true,
          kind: "meta",
          action: "align:top",
        },
        {
          id: "alignVCenter",
          label: "Alinear centro V",
          ready: true,
          kind: "meta",
          action: "align:vcenter",
        },
        {
          id: "alignBottom",
          label: "Alinear abajo",
          ready: true,
          kind: "meta",
          action: "align:bottom",
        },
        {
          id: "distributeH",
          label: "Distribuir H",
          ready: true,
          kind: "meta",
          action: "distribute:x",
        },
        {
          id: "distributeV",
          label: "Distribuir V",
          ready: true,
          kind: "meta",
          action: "distribute:y",
        },
      ],
      [
        {
          id: "dimension",
          label: "Cota",
          ready: true,
          kind: "mark",
          mark: "dimension",
        },
      ],
    ],
  },
  {
    category: "Texto",
    slots: [
      [
        {
          id: "type",
          label: "Texto",
          shortcut: "T",
          ready: true,
          kind: "mark",
          mark: "text",
        },
        {
          id: "areaType",
          label: "Texto de área",
          ready: true,
          kind: "mark",
          mark: "areaType",
        },
        {
          id: "verticalAreaType",
          label: "Texto de área vertical",
          ready: true,
          kind: "mark",
          mark: "verticalAreaType",
        },
        {
          id: "typeOnPath",
          label: "Texto en trazado",
          ready: true,
          kind: "meta",
          action: "typeOnPath",
        },
        {
          id: "verticalTypeOnPath",
          label: "Texto en trazado vertical",
          ready: true,
          kind: "meta",
          action: "verticalTypeOnPath",
        },
        {
          id: "verticalType",
          label: "Texto vertical",
          ready: true,
          kind: "mark",
          mark: "verticalType",
        },
        {
          id: "touchType",
          label: "Touch Type",
          ready: true,
          kind: "mark",
          mark: "touchType",
        },
        {
          id: "characterPanel",
          label: "Carácter…",
          ready: true,
          kind: "meta",
          action: "openCharacterPanel",
        },
        {
          id: "paragraphPanel",
          label: "Párrafo…",
          ready: true,
          kind: "meta",
          action: "openParagraphPanel",
        },
        {
          id: "createOutlines",
          label: "Create Outlines",
          shortcut: "Ctrl+Shift+O",
          ready: true,
          kind: "meta",
          action: "createOutlines",
        },
      ],
    ],
  },
  {
    category: "Navegar",
    slots: [
      [
        {
          id: "zoom",
          label: "Zoom",
          shortcut: "Z",
          ready: true,
          kind: "nav",
          action: "zoom",
        },
      ],
      [
        {
          id: "perspectiveGrid",
          label: "Perspective Grid",
          shortcut: "Shift+P",
          ready: true,
          kind: "meta",
          action: "perspectiveGrid",
        },
        {
          id: "perspectiveSelect",
          label: "Perspective Selection",
          shortcut: "Shift+V",
          ready: true,
          kind: "mark",
          mark: "perspectiveSelect",
        },
      ],
      [
        {
          id: "hand",
          label: "Mano",
          shortcut: "H · Espacio",
          ready: true,
          kind: "nav",
          action: "hand",
        },
        {
          id: "artboard",
          label: "Mesa de trabajo",
          shortcut: "Shift+O",
          ready: true,
          kind: "mark",
          mark: "artboard",
        },
        {
          id: "sendToPasteboard",
          label: "Sacar al fondo",
          shortcut: "Ctrl+Shift+B",
          ready: true,
          kind: "meta",
          action: "sendToPasteboard",
        },
      ],
      [
        {
          id: "rotateView",
          label: "Rotar vista",
          shortcut: "Shift+H",
          ready: true,
          kind: "meta",
          action: "rotateView",
        },
      ],
    ],
  },
  {
    // Color: cuentagotas + medida; Gradient abre dock (como VC Color).
    category: "Color",
    slots: [
      [
        {
          id: "gradient",
          label: "Degradado…",
          shortcut: "G",
          ready: true,
          kind: "meta",
          action: "openGradientPanel",
        },
        {
          id: "createGradientMesh",
          label: "Crear malla de degradado",
          ready: true,
          kind: "meta",
          action: "createGradientMesh",
        },
      ],
      [
        {
          id: "eyedropper",
          label: "Cuentagotas",
          shortcut: "I",
          ready: true,
          kind: "meta",
          action: "eyedropper",
        },
        {
          id: "measure",
          label: "Medición",
          ready: true,
          kind: "mark",
          mark: "measure",
        },
      ],
    ],
  },
];

export function flattenVcTools() {
  const out = [];
  VC_BASIC_TOOLBAR.forEach((cat) => {
    cat.slots.forEach((slot) => {
      slot.forEach((t) => out.push({ ...t, category: cat.category }));
    });
  });
  return out;
}

export function findVcTool(id) {
  return flattenVcTools().find((t) => t.id === id) || null;
}

/** Resuelve qué tool id debe mostrarse activo según estado moodboard. */
export function activeVcToolId({
  markTool,
  panInsideMode,
  handMode,
  zoomMode,
  multiSelectMode,
  eyedropperMode,
  freeTransformMode,
  spaceHeld = false,
}) {
  if (zoomMode) return "zoom";
  // Mano (H) o Espacio temporal — no confundir con pan-dentro de foto
  if (handMode || spaceHeld) return "hand";
  if (eyedropperMode) return "eyedropper";
  if (freeTransformMode) return "freeTransform";
  if (panInsideMode) return "selection";
  if (markTool === "brush") return "paintbrush";
  if (markTool === "vectorPen") return "pen";
  if (markTool === "addAnchor") return "addAnchor";
  if (markTool === "deleteAnchor") return "deleteAnchor";
  if (markTool === "directSelect") return "directSelection";
  if (markTool === "scissors") return "scissors";
  if (markTool === "lasso") return "lasso";
  if (markTool === "magicWand") return "magicWand";
  if (markTool === "livePaintBucket") return "livePaintBucket";
  if (markTool === "livePaintSelection") return "livePaintSelection";
  if (markTool === "pen") return "pencil";
  if (markTool === "line") return "lineSegment";
  if (markTool === "arc") return "arc";
  if (markTool === "spiral") return "spiral";
  if (markTool === "grid") return "rectangularGrid";
  if (markTool === "polarGrid") return "polarGrid";
  if (markTool === "flare") return "flare";
  if (markTool === "blob") return "blobBrush";
  if (markTool === "pathEraser") return "pathEraser";
  if (markTool === "anchorPoint") return "anchorPoint";
  if (markTool === "curvature") return "curvature";
  if (markTool === "lineCut") return "lineCut";
  if (markTool === "rectCut") return "rectCut";
  if (markTool === "mirrorCut") return "mirrorCut";
  if (markTool === "width") return "width";
  if (markTool === "warp") return "warp";
  if (markTool === "puppetWarp") return "puppetWarp";
  if (markTool === "twirl") return "twirl";
  if (markTool === "pucker") return "pucker";
  if (markTool === "bloat") return "bloat";
  if (markTool === "scallop") return "scallop";
  if (markTool === "crystallize") return "crystallize";
  if (markTool === "wrinkle") return "wrinkle";
  if (markTool === "reshape") return "reshape";
  if (markTool === "shaper") return "shaper";
  if (markTool === "shapeBuilder") return "shapeBuilder";
  if (markTool === "arrow") return "arrow";
  if (markTool === "ellipse") return "ellipse";
  if (markTool === "rect") return "rectangle";
  if (markTool === "roundrect") return "roundedRectangle";
  if (markTool === "polygon") return "polygon";
  if (markTool === "star") return "star";
  if (markTool === "measure") return "measure";
  if (markTool === "dimension") return "dimension";
  if (markTool === "objectsOnPath") return "objectsOnPath";
  if (markTool === "perspectiveSelect") return "perspectiveSelect";
  if (markTool === "artboard") return "artboard";
  if (markTool === "symbolShifter") return "symbolShifter";
  if (markTool === "symbolSprayer") return "symbolSprayer";
  if (markTool === "symbolScruncher") return "symbolScruncher";
  if (markTool === "symbolSizer") return "symbolSizer";
  if (markTool === "symbolSpinner") return "symbolSpinner";
  if (markTool === "symbolStainer") return "symbolStainer";
  if (markTool === "symbolScreener") return "symbolScreener";
  if (markTool === "knife") return "knife";
  if (markTool === "areaType") return "areaType";
  if (markTool === "verticalAreaType") return "verticalAreaType";
  if (markTool === "verticalType") return "verticalType";
  if (markTool === "touchType") return "touchType";
  if (markTool === "text") return "type";
  if (markTool === "eraser") return "eraser";
  if (markTool === "rotateDrag") return "rotate";
  if (markTool === "scaleDrag") return "scale";
  if (markTool === "shearDrag") return "shear";
  if (multiSelectMode) return "groupSelection";
  return "selection";
}
